"use client";

import { LoggedOutHomePage } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/LoggedOutHomePage";
import { RenderBuilderWithSSRProps } from "@faire/web--source/builder/BuilderComponents/types";
import React from "react";

export const RenderHomePage = ({
  builderVideoHeaderProps,
}: {
  builderVideoHeaderProps: RenderBuilderWithSSRProps | null;
}) => {
  return (
    <LoggedOutHomePage builderVideoHeaderProps={builderVideoHeaderProps} />
  );
};
